import * as React from 'react';
import { SVGProps } from 'react';

const IconAreaChartSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6 10.5-4-4V22h20V6.5h-3L14.5 2 6 10.5Zm14 4v-6h-1.828L14.5 4.828l-8.5 8.5-2-2V16.5l2 2 8.5-8.5 4.5 4.5h1Z"
    />
  </svg>
);
export default IconAreaChartSizeM;
